import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgModel } from '@angular/forms';
import { fuseAnimations } from "../../../core/animations";
import { ActivatedRoute, Router } from "@angular/router";
import { ElasticSearchService } from "../../../core/services/elastic-search.service";
import * as firebase from 'firebase';
import { AngularFirestore } from 'angularfire2/firestore';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { CategoryListModule } from '../category-list/category-list.module';

@Component({
    selector: 'app-set-product',
    templateUrl: './set-product.component.html',
    styleUrls: ['./set-product.component.scss'],
    animations: fuseAnimations
})
export class SetProductComponent implements OnInit {
    input: any;
    inputBrand: any;
    inputCategory: any;
    form: FormGroup;
    isAdmin = true;
    formErrors: any;
    categories = [];
    categoriesForCreate: Observable<any[]>;
    subCategories: any = [];
    midParentCategories: any = [];
    type: any;
    private sub: any;
    categoriesSearchArray = [];
    filteredCategories = [];
    queryString: any;
    hasParent: boolean = true;
    item = [];
    text: any = "";
    subCat = new Subscription();
    textTool: any = "";
    filteredStates: any[] = [];
    itemIndex: any = null;
    user = firebase.auth().currentUser;

    constructor(private elastic: ElasticSearchService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private afs: AngularFirestore,
        private cd: ChangeDetectorRef) {

        this.formErrors = {
            total: {},
            peopleCount: {},
            brand: {},
            category: {},
            selectedCategory: {},
            product: {},
            rateable: {},
            categoryName: {},
            midCategory: {},
            criter: {},
            desc: {},
            tooltip: {},
            loadCriterias: {}
        };


        this.subCat.add(this.afs.collection('categories', ref => ref.where('parent', '==', false).orderBy('name')).valueChanges().subscribe(data => {
            this.categories = data;
        }));
        this.categoriesForCreate = afs.collection('categories').valueChanges();

    }

    ngOnDestroy(): void {
        try {
            this.sub.unsubscribe();
            this.subCat.unsubscribe();
        } catch (e) {

        }
    }

    addCriteria(data, tooltip) {

        if (data == "") {
            return;
        }
        if (this.itemIndex != null) {

            this.item[this.itemIndex].name = data;
            this.item[this.itemIndex].tooltip = tooltip;

        } else {
            this.item.push({ name: data, point: 0, tooltip: tooltip });
        }
        this.text = "";
        this.textTool = "";
        this.itemIndex = null;
    }

    shuffleArray() {
        let array = [-0.4, -0.2, 0, 0.2, 0.4];

        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    }

    edit(data, index) {
        this.text = data.name;
        this.textTool = data.tooltip;
        this.itemIndex = index


    }

    delete(data) {
        this.item = this.item.filter(elem => {
            return data.name !== elem.name;
        });
    }

    onlyNumberKey(event) {
        return (event.charCode == 8 || event.charCode == 0 || event.charCode == 44 || event.charCode == 46) ? null : event.charCode >= 48 && event.charCode <= 57;
    }

    selectCriterias(value, chooseManuel?) {
        this.afs.collection('categories').ref.where('uniqueName', '==', this.changeTextCategory(value)).get().then(data => {
            if ((this.type == 'brand' || this.type == 'categories') && data.docs[0].data().criterias && !this.queryString) {
                this.item = [];
                this.item = data.docs[0].data().criterias ? data.docs[0].data().criterias : [];
            }
            if ((this.type == 'brand' || this.type == 'categories') && data.docs[0].data().criterias && chooseManuel) {
                this.item = [];
                this.item = data.docs[0].data().criterias ? data.docs[0].data().criterias : [];
            }
        });

    }

    async  ngOnInit() {
        this.form = this.formBuilder.group({
            brand: ['', Validators.required],
            total: ['', Validators.required],
            peopleCount: ['', Validators.required],
            product: ['', Validators.required],
            category: ['', Validators.required],
            rateable: [true, Validators.required],
            categoryName: ['', Validators.required],
            criter: [''],
            selectedCategory: ['', Validators.required],
            midCategory: ['', Validators.required],
            tooltip: [''],
            desc: [''],
            loadCriterias: ['']
        });

        this.type = this.route.snapshot.params['type'];
        this.queryString = this.route.snapshot.queryParams['name'];

        if (this.queryString) {
            this.isAdmin = false;
            let midCat;
            if (this.type == "brand") {

                this.afs.collection('brands').ref.where('uniqueName', '==', this.queryString).get().then(snap => {
                    if (snap.docs[0].data().selectedCategory) {

                        this.afs.collection('categories').ref.where('uniqueName', '==', snap.docs[0].data().selectedCategory)
                            .get().then(cat => {
                                console.log(cat.docs[0].data())
                                if (cat.docs[0].data().parent === this.changeTextCategory((snap.docs[0].data().category))) {
                                    midCat = snap.docs[0].data().selectedCategory;
                                }
                                else {
                                    this.optionChange(cat.docs[0].data().parent, 'mid');
                                    midCat = cat.docs[0].data().parent;
                                }
                                this.form = this.formBuilder.group({
                                    brand: [snap.docs[0].data().name, Validators.required],
                                    category: [snap.docs[0].data().category, Validators.required],
                                    selectedCategory: [snap.docs[0].data().selectedCategory, Validators.required],
                                    rateable: [snap.docs[0].data().isRateable ? snap.docs[0].data().isRateable : false, Validators.required],
                                    midCategory: [midCat, Validators.required],
                                    criter: [''],
                                    tooltip: ['']
                                });
                                this.cd.markForCheck();
                                this.optionChange(snap.docs[0].data().category, 'sub');
                                this.afs.collection('entities').ref.where('uniqueName', '==', this.queryString).get()
                                    .then(entity => {
                                        entity.docs.map(data => {
                                            if (data.data().type === 'brand') {
                                                this.item = data.data().criterias;
                                            }
                                        })
                                    });


                            })
                    }
                    else {
                        this.form = this.formBuilder.group({
                            brand: [snap.docs[0].data().name, Validators.required],
                            category: [snap.docs[0].data().category, Validators.required],
                            selectedCategory: [snap.docs[0].data().selectedCategory, Validators.required],
                            rateable: [snap.docs[0].data().isRateable ? snap.docs[0].data().isRateable : false, Validators.required],
                            midCategory: [midCat, Validators.required],
                            criter: [''],
                            tooltip: ['']
                        });

                    }
                })


            }
            if (this.type == "product") {

                this.afs.collection('products').ref.where('uniqueName', '==', this.queryString).get().then(snap => {
                    console.log(snap.docs[0].data());
                    this.optionChange(snap.docs[0].data().category, 'sub');
                    this.form = this.formBuilder.group({
                        product: [snap.docs[0].data().name, Validators.required],
                        brand: [snap.docs[0].data().brand, Validators.required],
                        category: [snap.docs[0].data().category, Validators.required],
                        selectedCategory: [snap.docs[0].data().selectedCategory, Validators.required],
                        midCategory: [snap.docs[0].data().selectedCategory, Validators.required],
                        criter: [''],
                        tooltip: ['']
                    });

                    this.cd.markForCheck();
                    if (snap.docs[0].data().selectedCategory) {
                        this.afs.collection('categories').ref.where('uniqueName', '==', this.changeTextCategory((snap.docs[0].data().selectedCategory)))
                            .get().then(cat => {

                                if (cat.docs[0].data().parent == this.changeTextCategory((snap.docs[0].data().selectedCategory))) {
                                    midCat = snap.docs[0].data().selectedCategory
                                }
                                else {
                                    this.optionChange(cat.docs[0].data().parent, 'mid');
                                    midCat = cat.docs[0].data().parent
                                }
                            });
                    }
                    this.afs.collection('entities').ref.where('uniqueName', '==', this.queryString).get().then(dta => {
                        console.log(dta.docs[0].data());
                        dta.forEach(a => {
                            if (a.data().type === 'product') {
                                this.item = a.data().criterias;
                            }
                        })
                    });






                });
                this.cd.markForCheck();


            }
            else if (this.type == "categories") {
                this.afs.collection('categories').ref.where('uniqueName', '==', this.queryString).get().then(snap1 => {

                    this.item = snap1.docs[0].data().criterias ? snap1.docs[0].data().criterias : [];
                    this.form = this.formBuilder.group({
                        categoryName: [snap1.docs[0].data().name, Validators.required],
                        category: [snap1.docs[0].data().parent ? snap1.docs[0].data().parent : "hasNoParent", Validators.required],
                        criter: [''],
                        tooltip: [''],
                        desc: [snap1.docs[0].data().desc ? snap1.docs[0].data().desc : '']
                    });
                    if (snap1.docs[0].data().parent && this.queryString) {
                        this.hasParent = false;
                        this.afs.collection('categories').ref.where('uniqueName', '==', snap1.docs[0].data().uniqueName).get().then(elem => {
                            this.form = this.formBuilder.group({
                                categoryName: [snap1.docs[0].data().name, Validators.required],
                                category: [elem.docs[0].data().name ? elem.docs[0].data().name : '', Validators.required],
                                criter: [''],
                                desc: [snap1.docs[0].data().desc ? snap1.docs[0].data().desc : ''],
                                tooltip: ['']
                            });
                        });
                    }
                    this.sub = this.afs.collection('categories').valueChanges().subscribe(res => {
                        this.categoriesSearchArray = res;
                    });


                });
            }


        } else {
            if (this.type == "categories") {
                this.hasParent = false;
                this.form = this.formBuilder.group({
                    categoryName: ["", Validators.required],
                    category: ["hasNoParent", Validators.required],
                    criter: [''],
                    tooltip: [''],
                    desc: ['']
                });
                this.sub = this.afs.collection('categories').valueChanges().subscribe(res => {
                    this.categoriesSearchArray = res;
                });
            } else if (this.type == "brand") {
                this.form = this.formBuilder.group({
                    brand: ["", Validators.required],
                    criter: [''],
                    tooltip: [''],
                    category: ["", Validators.required],
                    selectedCategory: ['', Validators.required],
                    midCategory: ['', Validators.required],
                    rateable: [true, Validators.required],
                    total: ['', Validators.required],
                    peopleCount: ['', Validators.required]
                });
            } else if (this.type == "product") {

                this.item = [
                    { name: "Fiyat/Fayda", point: 0, tooltip: "" },
                    { name: "Ürün Kalitesi", point: 0, tooltip: "" },
                    { name: "Ürün & Ambalaj Tasarımı", point: 0, tooltip: "Ürün tasarımı, ambalaj tasarımı vb. ürünün müşteriye sunumu ile ilgili tüm değerlendirmeleri ifade eder. " },
                    { name: "Ürün Özellikleri", point: 0, tooltip: "Ürünün kategorisine özgü özellikleri karşılaması ile ilgili müşteri memnuniyetini ifade eder." },
                    { name: "Ürün Özgünlüğü", point: 0, tooltip: "Ürünün kendine özgü niteliklere sahip olması ile ürünün müşteri ihtiyaçlarını karşılamada sunduğu farklılığı ifade eder. " }
                ];
            }
        }

        this.form.valueChanges.subscribe(() => {
            this.onFormValuesChanged();
        });
    }

    async optionChange(data, cat, chooseManuel?) {

        if (chooseManuel)
            this.selectCriterias(data, chooseManuel);
        this.selectCriterias(data);
        let parent = this.changeTextCategory(data);
        await this.afs.collection('categories').ref.where('parent', '==', parent).get().then(snap => {
            if (!snap.empty) {
                if (cat == 'sub') {
                    this.subCategories = [];
                }
                if (cat == 'mid') {
                    this.midParentCategories = [];
                }
                snap.forEach(data => {
                    if (cat == 'sub') {
                        this.subCategories.push(data.data());
                        console.log(this.subCategories)
                        this.cd.markForCheck();
                    }
                    if (cat == 'mid') {
                        this.midParentCategories.push(data.data());
                    }
                    return false;
                });

            }
        });
        this.cd.markForCheck();

    }

    onFormValuesChanged() {
        for (const field in this.formErrors) {
            if (!this.formErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.formErrors[field] = {};

            // Get the control
            const control = this.form.get(field);

            if (control && control.dirty && !control.valid) {
                this.formErrors[field] = control.errors;
            }
        }
    }

    changeText(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '')
            .replace(/\-/g, '')
            .replace(/\'/g, '')
            .replace(/\s/g, '')
            .toLowerCase();
    }

    changeTextCategory(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/-/g, '')
            .replace(/\./g, '_')
            .replace(/\'/g, '')
            .replace(/\s/g, '_').toLowerCase();
    }

    async insertUpdate(data) {


        if (this.type == "product") {
            if (this.queryString) {
                console.log(data)
                await this.afs.collection("products").ref.where("uniqueName", "==", this.queryString).get().then((products => {

                    this.afs.collection("products").ref.doc(products.docs[0].id).update({
                        name: data.product,
                        brand: this.changeText(data.brand),
                        uniqueName: this.queryString,
                        category: data.category,
                        selectedCategory: data.midCategory ? data.midCategory : data.selectedCategory,
                        criterias: products.docs[0].data().criterias ? products.docs[0].data().criterias : this.item ? this.item : ''

                    }).then(() => {


                        let newCri: any = this.item;
                        newCri.forEach(element => {
                            element.total = null;
                            element.peopleCount = null;
                        });
                        this.afs.collection('entities').ref.where('uniqueName', '==', this.queryString).get().then(entity => {
                            entity.docs.map(product => {
                                if (product.data().type === 'product') {
                                    this.afs.collection('entities').doc(product.id).update({
                                        name: data.product,
                                        uniqueName: this.queryString,
                                        type: "product",
                                        peopleCount: products.docs[0].data().peopleCount ? products.docs[0].data().peopleCount : 0,
                                        total: products.docs[0].data().total ? products.docs[0].data().total : 0,
                                        brand: this.changeText(data.brand),
                                        category: data.category,
                                        criterias: newCri.length > 0 ? newCri : null,
                                        searchTerm: data.product.replace(/\s/g, '') + this.queryString

                                    });
                                }
                            });
                        });
                    });

                }));
                this.router.navigate(['productlist']);


            } else if (!this.queryString && data.category != "" && data.product != "") {
                data.total = data.total.replace(',', '.');
                let newCri: any = this.item;
                newCri.forEach(element => {
                    element.total = null;
                    element.peopleCount = null;
                });

                this.afs.collection("entities").add({
                    name: data.product,
                    uniqueName: this.changeText(data.product),
                    type: "product",
                    total: parseFloat(data.total) ? parseFloat(data.total) * parseInt(data.peopleCount) : 0,
                    peopleCount: parseInt(data.peopleCount) ? parseInt(data.peopleCount) : 0,
                    category: data.category,
                    selectedCategory: data.selectedCategory != "" ? data.selectedCategory : data.midCategory != "" ? data.midCategory : "",
                    criterias: newCri,
                    searchTerm: data.product.replace(/\s/g, '') + this.changeText(data.product)
                });


                if (parseFloat(data.total)) {
                    let shuffle = this.shuffleArray();
                    let peopleCountforcat = parseInt(data.peopleCount);
                    let totalforcat = parseInt(data.total);
                    this.item.forEach((shu, index) => {
                        shu.total = parseFloat(data.total) > 0.4 && parseFloat(data.total) < 9.6 ? (parseFloat(data.total) + shuffle[index]) * parseInt(data.peopleCount) : parseFloat(data.total) * parseInt(data.peopleCount);
                        shu.peopleCount = parseInt(data.peopleCount);
                    });
                    this.afs.collection('brands').ref.where('uniqueName', '==', this.changeText(data.brand)).get().then(brandData => {
                        this.afs.collection('brands').doc(brandData.docs[0].id).collection('categories').ref.where('name', '==', data.category)
                            .get().then(category => {
                                if (!category.empty) {
                                    this.afs.collection('brands').doc(brandData.docs[0].id).collection('categories').doc(category.docs[0].id)
                                        .update({
                                            criterias: this.item,
                                            name: data.category,
                                            total: parseFloat(data.total) * parseInt(data.peopleCount),
                                            peopleCount: parseInt(data.peopleCount)
                                        });

                                }




                            })
                    })


                } else {
                    this.item = [
                        { name: "Fiyat/Fayda", total: 0, peopleCount: 0, tooltip: "" },
                        { name: "Ürün Kalitesi", total: 0, peopleCount: 0, tooltip: "" },
                        { name: "Ürün & Ambalaj Tasarımı", total: 0, peopleCount: 0, tooltip: "Ürün tasarımı, ambalaj tasarımı vb. ürünün müşteriye sunumu ile ilgili tüm değerlendirmeleri ifade eder. " },
                        { name: "Ürün Özellikleri", total: 0, peopleCount: 0, tooltip: "Ürünün kategorisine özgü özellikleri karşılaması ile ilgili müşteri memnuniyetini ifade eder." },
                        { name: "Ürün Özgünlüğü", total: 0, peopleCount: 0, tooltip: "Ürünün kendine özgü niteliklere sahip olması ile ürünün müşteri ihtiyaçlarını karşılamada sunduğu farklılığı ifade eder. " }
                    ];
                }

                this.afs.collection("products").add({
                    name: data.product,
                    uniqueName: this.changeText(data.product),
                    type: "product",
                    category: data.category,
                    averageRate: parseFloat(data.total) ? parseFloat(data.total) : 0,
                    total: parseFloat(data.total) ? parseFloat(data.total) * parseInt(data.peopleCount) : 0,
                    peopleCount: parseInt(data.peopleCount) ? parseInt(data.peopleCount) : 0,
                    brand: this.changeText(data.brand),
                    criterias: this.item,
                    breadcrumb: data.category + ">" + data.midCategory + ">" + data.selectedCategory,
                    selectedCategory: data.selectedCategory != "" ? data.selectedCategory : data.midCategory != "" ? data.midCategory : ""
                });


                this.router.navigate(['productlist']);

            }
        }

        if (this.type == "brand") {
            if (!this.queryString && data.category != "" && data.brand != "") {
                data.total = data.total.replace(',', '.');
                let newCri: any = this.item;
                newCri.forEach(element => {
                    element.total = element.total ? element.total : 0;
                    element.peopleCount = element.peopleCount ? element.peopleCount : 0;
                    element.point = 0;
                });
                console.log(this.queryString)
                await this.afs.collection('entities').add({
                    name: data.brand,
                    uniqueName: this.changeText(data.brand),
                    type: "brand",
                    category: data.category,
                    total: parseFloat(data.total) ? parseFloat(data.total) * parseInt(data.peopleCount) : 0,
                    peopleCount: parseInt(data.peopleCount) ? parseInt(data.peopleCount) : 0,
                    isRateable: data.rateable,
                    criterias: newCri,
                    selectedCategory: data.selectedCategory != "" ? data.selectedCategory : data.midCategory != "" ? data.midCategory : "",
                    searchTerm: data.brand.replace(/\s/g, '') + this.changeText(data.brand)
                });



                if (parseFloat(data.total)) {
                    let shuffle = this.shuffleArray();
                    this.item.forEach((shu, index) => {
                        shu.total = parseFloat(data.total) > 0.4 && parseFloat(data.total) < 9.6 ? (parseFloat(data.total) + shuffle[index]) * parseInt(data.peopleCount) : parseFloat(data.total) * parseInt(data.peopleCount);
                        shu.peopleCount = parseInt(data.peopleCount);
                        shu.point = null;
                    });
                }
                await this.afs.collection('brands').add({
                    name: data.brand,
                    uniqueName: this.changeText(data.brand),
                    type: "brand",
                    category: data.category,
                    selectedCategory: data.selectedCategory != "" ? data.selectedCategory : data.midCategory != "" ? data.midCategory : "",
                    averageRate: parseFloat(data.total) ? parseFloat(data.total) : 0,
                    total: parseFloat(data.total) ? parseFloat(data.total) * parseInt(data.peopleCount) : 0,
                    peopleCount: parseInt(data.peopleCount) ? parseInt(data.peopleCount) : 0,
                    isRateable: data.rateable
                }).then((x => {

                    this.afs.collection('brands').doc(x.id).collection('categories').add({
                        criterias: this.item,
                        name: "Genel",
                        peopleCount: parseInt(data.peopleCount) ? parseInt(data.peopleCount) : 0,
                        total: parseFloat(data.total) ? parseFloat(data.total) * parseInt(data.peopleCount) : 0
                    }).then(() => {
                        this.afs.collection('categories').ref.where('name', '==', data.category).get().then(category => {
                            this.afs.collection('brands').doc(x.id).collection('categories').add({
                                criterias: category.docs[0].data().criterias,
                                name: data.category,
                                peopleCount: parseInt(data.peopleCount) ? parseInt(data.peopleCount) : 0,
                                total: parseFloat(data.total) ? parseFloat(data.total) * parseInt(data.peopleCount) : 0
                            });
                        });
                    });
                }));


                // await this.afs.collection('categories').add({
                //     name: data.brand,
                //     uniqueName: this.changeText(data.brand),
                //     type: "brand",
                //     averageRate: parseFloat(data.total) ? parseFloat(data.total) : 0
                // });
                this.router.navigate(['brandlist']);

            } else if (this.queryString) {
                await this.afs.collection('brands').ref.where('uniqueName', '==', this.queryString).get().then((oldData => {

                    const oldDatas = oldData.docs[0].data();
                    this.afs.collection('brands').doc(oldData.docs[0].id).update({
                        name: data.brand,
                        category: data.category,
                        selectedCategory: data.midCategory ? data.midCategory : data.selectedCategory,
                        isRateable: data.rateable
                    });
                    let newCri: any = this.item;
                    newCri.forEach(element => {
                        element.total = null;
                        element.peopleCount = null;
                        element.point = 0;
                    });
                    this.afs.collection('entities').ref.where('uniqueName', '==', this.queryString).get()
                        .then(entitiy => {
                            this.afs.collection('entities').doc(entitiy.docs[0].id).update({
                                name: data.brand,
                                category: data.category,
                                selectedCategory: data.midCategory ? data.midCategory : data.selectedCategory,
                                isRateable: data.rateable,
                                criterias: newCri.length > 0 ? newCri : ''
                            });
                        });
                }));
                this.router.navigate(['brandlist']);

            }
        }

        if (this.type == "categories") {
            if (!this.queryString && data.category != "" && data.categoryName != "") {
                if (data.category == 'hasNoParent') {
                    console.log("hhh")

                    this.afs.collection('categories').add({
                        name: data.categoryName.trim(),
                        uniqueName: this.changeTextCategory(data.categoryName.trim()),
                        parent: false,
                        desc: data.desc,
                        criterias: this.item ? this.item : []
                    });

                    this.afs.collection('entities').add({
                        name: data.categoryName.trim(),
                        uniqueName: this.changeTextCategory(data.categoryName.trim()),
                        searchTerm: data.categoryName.trim().replace(/\s/g, '') + this.changeTextCategory(data.categoryName.trim()),
                        type: "category"
                    });

                } else {
                    console.log("giriririi")

                    this.afs.collection('categories').add({
                        name: data.categoryName.trim(),
                        uniqueName: this.changeTextCategory(data.categoryName.trim()),
                        parent: this.changeTextCategory(data.category) || false,
                        desc: data.desc,
                        criterias: this.item ? this.item : []
                    })

                    this.afs.collection('entities').add({
                        name: data.categoryName.trim(),
                        uniqueName: this.changeTextCategory(data.categoryName.trim()),
                        searchTerm: data.categoryName.trim().replace(/\s/g, '') + this.changeTextCategory(data.categoryName.trim()),
                        type: "category"
                    })

                }
                this.router.navigate(['categorylist']);

            } else if (this.queryString && data.category != "" && data.categoryName != "") {
                console.log("isdf")
                console.log(data)
                this.afs.collection('categories').ref.where('uniqueName', '==', this.queryString).get().then((value) => {
                    if (value) {
                        console.log(value.docs[0].id)
                        console.log(this.item)
                        this.afs.collection('categories').doc(value.docs[0].id).update({
                            name: data.categoryName.trim(),
                            desc: data.desc ? data.desc : '',
                            criterias: this.item ? this.item : [],
                            parent: this.changeTextCategory(data.category) && data.category != "hasNoParent" ? this.changeTextCategory(data.category) : false
                        });
                        if (!value.docs[0].data().parent) {
                            this.afs.collection('entities').doc(value.docs[0].id).update({
                                name: data.categoryName.trim(),
                                uniqueName: this.queryString,
                                searchTerm: data.categoryName.replace(/\s/g, '').replace(/\,/g, '') + this.queryString,
                                type: "category"
                            });
                        }
                    }

                    this.afs.collection('entities').ref.where('category', '==', value.docs[0].data().name).get().then((entities) => {
                        entities.forEach(cat => {
                            this.afs.collection('entities').doc(cat.id).update({
                                category: data.categoryName.trim()
                            })
                            return false;
                        });
                    })



                })


                this.router.navigate(['categorylist']);
            }
        }
    }

    public inputKeyUp(inputType) {
        let searchInput: any;
        let input = this.input ? this.input : this.inputBrand
        if (inputType != "category") {
            if (input.length >= 3) {
                searchInput = inputType == 'product' ? this.input.replace(/\s/g, '').replace(/@/g, '').replace(/,/g, '').replace(/'/g, '').replace(/\./g, '').toLowerCase().trim() :
                    this.inputBrand.replace(/\s/g, '').replace(/@/g, '').replace(/,/g, '').replace(/'/g, '').replace(/\./g, '').toLowerCase().trim();

                let query = {
                    searchTerm: searchInput,
                    types: [inputType]
                };

                this.elastic.doSearch("SearchTermAndType", query).then((arr: any[]) => {
                    this.filteredStates = arr;
                });

            }
        } else {

        }

    }

    searchKeyUp() {

        let searchInput = this.inputCategory.replace(/\s/g, '').replace(/@/g, '').replace(/,/g, '').replace(/'/g, '').replace(/\./g, '').toLowerCase().trim();
        this.filteredCategories = this.categoriesSearchArray.filter(
            item => {
                return this.changeTextCategory(item.name).indexOf(this.changeTextCategory(searchInput)) > -1
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/set-product/set-product.component.ts